import { Button } from './button';

/** Full-screen message with an optional action (errors, "open in Telegram", empty shells). */
export function ScreenMessage({
	title,
	body,
	action,
	emoji,
}: {
	title: string;
	/** A big emoji above the title (empty states, T-1311). */
	emoji?: string;
	body?: string;
	action?: { label: string; onClick: () => void };
}) {
	return (
		<div className="flex h-full flex-col items-center justify-center gap-3 px-6 text-center">
			{emoji !== undefined && (
				<span aria-hidden="true" className="animate-pop text-[56px] leading-none">
					{emoji}
				</span>
			)}
			<h1 className="text-h2 font-bold">{title}</h1>
			{body !== undefined && <p className="text-body text-text-muted">{body}</p>}
			{action !== undefined && (
				<Button className="mt-3" onClick={action.onClick}>
					{action.label}
				</Button>
			)}
		</div>
	);
}
